import useHasRate from '../../hooks/useHasRate'
import {useIsAuth, useLogout} from '../../hooks/auth'
import Button from '../../ui/Button/Button'
import Logo from '../../ui/Logo/Logo'
import styles from './Header.module.scss'
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { AUTH_URL, FILTERS_URL, LOGOUT_URL, VACANCIES_URL } from '../../utils/consts'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import Drawer from '@mui/material/Drawer';
import { useEffect, useMemo, useRef, useState } from 'react'
import { useWindowWidth } from '../../hooks/common'
import { Box } from '@mui/material'
import NotificationBtn from '../Notifications/NotificationBtn/NotificationBtn'
import NotificationsModal from '../Notifications/NotificationModal/NotificationsModal'

const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const logout = useLogout()
  const {data: isAuth} = useIsAuth()
  const hasRate = useHasRate()

  const windowWidth = useWindowWidth()
  const [menuOpen, setMenuOpen] = useState(false)

  const [notificationsOpen, setNotificationsOpen] = useState(false)
  const notificationRef = useRef(null)

  return (
    (
      <div className={styles.header}>
        <div className={styles.row}>
          <Logo />
        </div>
        <div className={styles.row}>
          {!isAuth &&
            <>
              <NotificationBtn modalIsOpen={notificationsOpen} anchorRef={notificationRef} ref={notificationRef} setModalIsOpen={setNotificationsOpen}/>
              <NotificationsModal anchorEl={notificationRef.current} isOpen={notificationsOpen}/>
            </>
          }
          {!isAuth &&
            <Button
              onClick={() => { navigate(AUTH_URL) }}
              kind='black'
            >
              <p>
                Вход
              </p>
            </Button>
          }
          {windowWidth > 767
            ?
            <>
              {isAuth && <Link to={VACANCIES_URL}><h2>Вакансии</h2></Link>}
              {isAuth && hasRate &&
                <SettingsApplicationsIcon
                  className={styles.settingsIcon}
                  onClick={() => { navigate(FILTERS_URL) }}
                />
              }
              {isAuth &&
                <>
                  <NotificationBtn modalIsOpen={notificationsOpen} anchorRef={notificationRef} ref={notificationRef} setModalIsOpen={setNotificationsOpen}/>
                  <NotificationsModal anchorEl={notificationRef.current} isOpen={notificationsOpen}/>
                </>
              }
              {isAuth &&
                <Button
                  onClick={() => {logout.mutate()}}
                  className={styles.logout}
                  kind='black'
                >
                  <p>Выход</p>
                </Button>}
            </>
            :
            <>
              {isAuth &&
                <>
                  <NotificationBtn modalIsOpen={notificationsOpen} anchorRef={notificationRef} setModalIsOpen={setNotificationsOpen}/>
                  <NotificationsModal anchorEl={notificationRef.current} isOpen={notificationsOpen}/>
                </>
              }
              {isAuth && <MenuIcon className={styles.menu} onClick={() => { setMenuOpen(true) }} />}
              <Drawer
                open={menuOpen}
                onClose={() => { setMenuOpen(false) }}
              >
                <Box
                  className={styles.drawer}
                  onClick={() => { setMenuOpen(false) }}
                >
                  {isAuth && <Link to={VACANCIES_URL}><h2>Вакансии</h2></Link>}
                  {isAuth && hasRate && <Link to={FILTERS_URL}><h2>Фильтры</h2></Link>}
                  {isAuth &&
                    <Button
                      onClick={() => {logout.mutate()}}
                      className={styles.logout}
                      kind='black'
                    >
                      <p>Выход</p>
                    </Button>
                  }
                </Box>
              </Drawer>
            </>
          }

        </div>
      </div>
    )
  )
}

export default Header